/**
 * Audit log utility functions and constants.
 * Extracted to a separate file for testability and reuse.
 */

export const ACTION_LABELS = {
    'appointment.created': 'Appointment Created',
    'appointment.updated': 'Appointment Updated',
    'appointment.cancelled': 'Appointment Cancelled',
    'appointment.completed': 'Appointment Completed',
    'appointment.reopened': 'Appointment Reopened',
    'patient.created': 'Patient Added',
    'patient.updated': 'Patient Updated',
    'charge.created': 'Charge Created',
    'charge.paid': 'Charge Paid',
    'charge.deleted': 'Charge Deleted',
    'agreement.created': 'Agreement Created',
    'agreement.updated': 'Agreement Updated',
    'agreement.deleted': 'Agreement Deleted',
    'invoice.created': 'Invoice Created',
    'invoice.cancelled': 'Invoice Cancelled',
    'clinic.updated': 'Clinic Updated',
    'clinic.images_updated': 'Images Updated',
    'clinic.notification_settings_updated': 'Notifications Updated',
    'member.added': 'Member Added',
    'member.updated': 'Member Updated',
    'member.removed': 'Member Removed',
    'note.created': 'Note Added',
};

export const getActionStyle = (action) => {
    if (action.includes('created') || action.includes('added')) return { bg: '#dcfce7', color: '#166534', dot: '#22c55e' };
    if (action.includes('updated') || action.includes('paid')) return { bg: '#dbeafe', color: '#1e40af', dot: '#3b82f6' };
    if (action.includes('deleted') || action.includes('removed') || action.includes('cancelled')) return { bg: '#fee2e2', color: '#991b1b', dot: '#ef4444' };
    if (action.includes('viewed') || action.includes('exported')) return { bg: '#f1f5f9', color: '#475569', dot: '#94a3b8' };
    return { bg: '#f5f3ff', color: '#5b21b6', dot: '#8b5cf6' };
};

export const formatAuditTimestamp = (ts) => {
    const d = new Date(ts);
    const now = new Date();
    const diffMs = now - d;
    const diffMins = Math.floor(diffMs / 60000);
    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours}h ago`;
    const diffDays = Math.floor(diffHours / 24);
    if (diffDays < 7) return `${diffDays}d ago`;
    return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: d.getFullYear() !== now.getFullYear() ? 'numeric' : undefined });
};
